import { DWH_EVENTS } from '@media-platform/dwh-logger/build/constants';
import { hitDWHEvent, attachChildrenToDWH } from 'Src/tools/dwhLogger';
import type { IStateWithPermission } from '@media-platform/push-notifications-tooltip/src/core/Model';

const hitDWHEventPushNotifications = (type: string) => {
  hitDWHEvent({
    type: DWH_EVENTS.ELEMENT_CLICK,
    params: {
      element_type: type,
    },
  });
};

export const logger = {
  ready: (data: IStateWithPermission) =>
    hitDWHEventPushNotifications(
      data.isSubscribed ? 'PushSubscribed' : 'PushUnSubscribed'
    ),
  error: () => hitDWHEventPushNotifications('PushUnSubscribeError'),
  subscribe: () => hitDWHEventPushNotifications('PushSubscribe'),
  unsubscribe: () => hitDWHEventPushNotifications('PushUnSubscribe'),
  attachChildren: (container: HTMLElement) => {
    if (container) {
      attachChildrenToDWH({ root: container });
    }
  },
};
